import React from 'react'

const FeatureScalingDoc = () => {
  return (
    <div className='container'>
        <h1 className='text-light text-center'>Feature Scaling</h1>

      <p className='text-light'>
        Feature scaling is a technique used in machine learning to normalize the range of features of a dataset. This is important because some algorithms, such as k-nearest neighbors and support vector machines, are sensitive to the scale of the features and can produce poor results if the features are not scaled. Common methods for feature scaling include standardization and normalization.
    </p>
    </div>
  )
}

export default FeatureScalingDoc
